import { MonitoringFailureReason } from '../monitoring-anomaly.model';
import { MonitoringSystemDetail } from '../monitoring-detection.service';
import { AnomalyChecker } from './anomaly-checker.interface';

/**
 * Anomaly checker for PostHog
 */
export class PosthogAnomalyChecker implements AnomalyChecker {
  readonly key = 'posthog';
  readonly name = 'PostHog';

  check(): MonitoringSystemDetail {
    const result: MonitoringSystemDetail = {
      isActive: false,
      scriptLoaded: false,
      lastChecked: Date.now(),
    };

    try {
      if (typeof window === 'undefined') {
        result.failureReason = MonitoringFailureReason.UNKNOWN;
        return result;
      }

      // Check if script tag exists
      const scriptTag = document.querySelector(
        'script[src*="posthog"], script[src*="us.posthog.com"]',
      );
      result.scriptLoaded = scriptTag !== null;

      const posthog = (window as any).posthog;

      // Check if posthog object exists and has required methods
      if (
        posthog &&
        (typeof posthog.capture === 'function' ||
          typeof posthog.identify === 'function' ||
          typeof posthog.init === 'function')
      ) {
        result.isActive = true;
        return result;
      }

      // Determine failure reason
      if (!result.scriptLoaded) {
        result.failureReason = MonitoringFailureReason.NOT_LOADED;
      } else if (posthog) {
        result.failureReason = MonitoringFailureReason.NOT_INITIALIZED;
      } else {
        result.failureReason = MonitoringFailureReason.BLOCKED;
      }

      return result;
    } catch (error) {
      console.error(
        `[MonitoringDetection] Error checking ${this.name}:`,
        error,
      );
      result.failureReason = MonitoringFailureReason.UNKNOWN;
      return result;
    }
  }
}
